namespace Matrix.Indexation {
    export interface IndexationProfileForm {
        IndexationProfileCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        IndexationInstanceId: Serenity.StringEditor;
        EffectiveDate: Serenity.DateEditor;
        ValidFrom: Serenity.DateTimeEditor;
        ValidTo: Serenity.DateTimeEditor;
        ShortName: Serenity.StringEditor;
        DefaultSortOrder: Serenity.IntegerEditor;
        SecurityList: IndexationProfileSecuritiesEditGrid;
        Prices: IndexationProfilePriceGrid;
        Returns: IndexationProfileIndexRorGrid;
        CompositeConstituents: IndexationProfileCompositeConstituentGrid;
        ConstituentReturns: IndexationProfileIndexConstituentRorGrid;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
        CloningIndexationProfileCode: Serenity.StringEditor;
    }

    export class IndexationProfileForm extends Serenity.PrefixedContext {
        static formKey = 'Indexation.IndexationProfile';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IndexationProfileForm.init)  {
                IndexationProfileForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.DateTimeEditor;
                var w3 = s.IntegerEditor;
                var w4 = IndexationProfileSecuritiesEditGrid;
                var w5 = IndexationProfilePriceGrid;
                var w6 = IndexationProfileIndexRorGrid;
                var w7 = IndexationProfileCompositeConstituentGrid;
                var w8 = IndexationProfileIndexConstituentRorGrid;
                var w9 = StaticTextBlock;
                var w10 = ReadOnlyDateTime;

                Q.initFormType(IndexationProfileForm, [
                    'IndexationProfileCode', w0,
                    'Name', w0,
                    'IndexationInstanceId', w0,
                    'EffectiveDate', w1,
                    'ValidFrom', w2,
                    'ValidTo', w2,
                    'ShortName', w0,
                    'DefaultSortOrder', w3,
                    'SecurityList', w4,
                    'Prices', w5,
                    'Returns', w6,
                    'CompositeConstituents', w7,
                    'ConstituentReturns', w8,
                    'CreatedBy', w9,
                    'CreatedWhen', w10,
                    'UpdatedBy', w9,
                    'UpdatedWhen', w10,
                    'Version', w9,
                    'CloningIndexationProfileCode', w0
                ]);
            }
        }
    }
}
